import { createFileRoute } from '@tanstack/react-router';

import { PrivacyPage } from '@/features/legal/routes/PrivacyPage';

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
});
